import { CssStates, embeddedImagesBase64, IGrapesJSProjectData } from "../../../interfaces/VisageUI";

const GjsTemplateBlank: IGrapesJSProjectData = {
	"assets":[

	],
	"styles":[
		{
			"selectors":[

			],
			"selectorsAdd":"body",
			"style":{
				"width":"100vw",
				"height":"100vh",
				"background-color":"transparent"
			}
		},
		{
			"selectors":[
				"gjs-plh-image"
			],
			"style":{
				"background-image":"none",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"outline-color":"initial",
				"outline-style":"none",
				"outline-width":"initial"
			}
		},
		{
			"selectors":[
				"#Cf3d3d78b-3ad4-4afd-a1b7-b2fe41d9c616"
			],
			"style":{
				"width":"100%",
				"height":"100%",
				"display":"flex",
				"align-content":"center",
				"align-items":"center",
				"flex-direction":"column",
				"justify-content":"center"
			}
		},
		{
			"selectors":[
				"Btn_SecondaryCTA"
			],
			"style":{
				"__background-type":"grad",
				"background-repeat":"repeat",
				"background-position":"left top",
				"background-attachment":"scroll",
				"background-size":"auto",
				"background-image":"linear-gradient(to top, #b4b4b4 86%, #d5d5d5 100%)",
				"position":"relative",
				"margin":"0vw 0.5vw 0vw 0vw",
				"width":"20vw"
			}
		},
		{
			"selectors":[
				"Btn_Primary_CTA"
			],
			"style":{
				"position":"relative",
				"width":"20vw"
			}
		},
		{
			"selectors":[
				{
					"name":"Btn_SecondaryTest",
					"active":false
				}
			],
			"style":{
				"width":"20vw",
				"border":"0vw none black"
			}
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"background-image":"linear-gradient(rgb(164, 164, 164) 0%, rgb(126, 126, 126) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"background-color":"rgb(89, 89, 89)"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"background-color":"rgb(89, 89, 89)"
			},
			"state":CssStates.Active
		},
		{
			"selectors":[

			],
			"selectorsAdd":"*",
			"style":{
				"font-family":"Roboto, Arial, sans-serif"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar",
			"style":{
				"width":"10px",
				"height":"10px"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-track",
			"style":{
				"background-color":"rgb(51, 51, 51)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-corner",
			"style":{
				"background-color":"rgb(51, 51, 51)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-thumb",
			"style":{
				"background-color":"rgb(191, 191, 191)"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"::-webkit-scrollbar-thumb:hover",
			"style":{
				"background-color":"rgb(235, 235, 235)"
			}
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(255, 255, 255) 0%, rgb(239, 239, 239) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(48, 48, 48)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px"
			}
		},
		{
			"selectors":[
				"primary-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"20vw",
				"height":"4.5vw",
				"min-height":"4.5vw",
				"border-top-left-radius":"12vw",
				"border-top-right-radius":"12vw",
				"border-bottom-right-radius":"12vw",
				"border-bottom-left-radius":"12vw",
				"background-image":"linear-gradient(rgb(118, 118, 118) 0%, rgb(79, 79, 79) 100%)",
				"background-position-x":"initial",
				"background-position-y":"initial",
				"background-size":"initial",
				"background-repeat":"initial",
				"background-attachment":"initial",
				"background-origin":"initial",
				"background-clip":"initial",
				"background-color":"initial",
				"color":"rgb(235, 235, 235)",
				"font-size":"2vw",
				"box-shadow":"rgba(0, 0, 0, 0.4) 0px 0px 1vw 0px"
			}
		},
		{
			"selectors":[
				"secondary-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"9vw",
				"height":"9vw",
				"background-color":"rgba(30, 30, 30, 0.8)",
				"border-top-left-radius":"50%",
				"border-top-right-radius":"50%",
				"border-bottom-right-radius":"50%",
				"border-bottom-left-radius":"50%"
			}
		},
		{
			"selectors":[
				"primary-icon-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"display":"flex",
				"align-items":"center",
				"justify-content":"center",
				"width":"7.25vw",
				"height":"7.25vw",
				"background-color":"rgba(30, 30, 30, 0.8)",
				"border-top-left-radius":"50%",
				"border-top-right-radius":"50%",
				"border-bottom-right-radius":"50%",
				"border-bottom-left-radius":"50%"
			}
		},
		{
			"selectors":[
				"secondary-icon-cta"
			],
			"style":{
				"transform":"scale(1.05, 1.05)"
			},
			"state":CssStates.Hover
		},
		{
			"selectors":[

			],
			"selectorsAdd":"div[data-gjs-type=\"wrapper\"]",
			"style":{
				"height":"100vh",
				"width":"100vw"
			}
		},
		{
			"selectors":[
				"#C131bc0b8-e68c-4e99-8146-ef805a9457cd"
			],
			"style":{
				"position":"absolute",
				"bottom":"2vw",
				"left":"2vw",
				"background":"rgba(30, 30, 30, 0.9)",
				"border-top-left-radius":"3.625vw",
				"border-top-right-radius":"3.625vw",
				"border-bottom-right-radius":"3.625vw",
				"border-bottom-left-radius":"3.625vw",
				"display":"flex",
				"padding-bottom":"0.5vw"
			}
		},
		{
			"selectors":[
				"#C362cc898-d7a2-4ba3-9dc8-72697c95cb5a"
			],
			"style":{
				"width":"70%",
				"height":"70%"
			}
		},
		{
			"selectors":[
				"#Ca71e6c6c-5d67-4444-8b21-4a816f989b40"
			],
			"style":{
				"position":"absolute",
				"right":"1.5vw",
				"top":"calc(50% + 0vw)",
				"transform":"translateY(-50%)",
				"display":"flex",
				"align-items":"center",
				"flex-direction":"column",
				"justify-content":"center",
				"width":"8.999583333333332vw",
				"height":"17.24898148148148vw"
			}
		},
		{
			"selectors":[
				"#Cd08a9630-2986-4590-9960-4cabf0a3df30"
			],
			"style":{
				"position":"absolute",
				"background":"rgba(30, 30, 30, 0.9)",
				"border-top-left-radius":"4.5vw",
				"border-top-right-radius":"4.5vw",
				"border-bottom-right-radius":"4.5vw",
				"border-bottom-left-radius":"4.5vw",
				"width":"9vw",
				"height":"9vw",
				"padding-left":"0.5vw",
				"margin-top":"0vw",
				"margin-bottom":"1vw",
				"margin-left":"0vw",
				"margin-right":"0vw",
				"padding-top":"1.5vw",
				"padding-bottom":"1.5vw",
				"top":"0vw",
				"left":"calc(50% + 0vw)",
				"transform":"translateX(-50%)"
			}
		},
		{
			"selectors":[
				"#Cc4797c47-683c-4177-9edf-7d2f5a0d4e5c"
			],
			"style":{
				"height":"100%"
			}
		},
		{
			"selectors":[
				"#C90e696e9-8cf9-49b9-888b-17f2223c60cc"
			],
			"style":{
				"position":"absolute",
				"background":"rgba(30, 30, 30, 0.9)",
				"border-top-left-radius":"3.625vw",
				"border-top-right-radius":"3.625vw",
				"border-bottom-right-radius":"3.625vw",
				"border-bottom-left-radius":"3.625vw",
				"width":"7.25vw",
				"height":"7.25vw",
				"padding-right":"0.5vw",
				"padding-top":"1.25vw",
				"padding-bottom":"1.25vw",
				"left":"calc(50% + 0vw)",
				"bottom":"0vw",
				"transform":"translateX(-50%)"
			}
		},
		{
			"selectors":[
				"#Cb137d437-f3c7-4e93-b933-cb2a3fd5e144"
			],
			"style":{
				"height":"100%"
			}
		},
		{
			"selectors":[

			],
			"selectorsAdd":"text",
			"style":{
				"display":"inline-block",
				"min-width":"1vw",
				"min-height":"1vw"
			}
		},
		{
			"selectors":[
				"visageEditorDefaultContainer"
			],
			"style":{
				"position":"relative",
				"width":"100%",
				"height":"100%",
				"display":"flex",
				"align-items":"center",
				"justify-content":"center"
			}
		},
		{
			"selectors":[
				"#Ce373dd09-dd9e-4116-89c0-24040286d538"
			],
			"style":{
				"justify-content":"center",
				"align-items":"center",
				"width":"100%",
				"height":"6vw",
				"position":"absolute",
				"display":"none",
				"background":"rgba(30, 30, 30, 0.9)",
				"flex-direction":"row",
				"top":"0vw",
				"left":"calc(50% + 0vw)",
				"transform":"translateX(-50%)"
			}
		},
		{
			"selectors":[
				"#Cbcb826a2-876a-44bb-9cbf-b282719c4d6e"
			],
			"style":{
				"width":"auto",
				"height":"70%",
				"font-size":"2vw",
				"font-weight":"normal",
				"color":"#EBEBEB",
				"text-align":"left"
			}
		},
		{
			"selectors":[
				"#Cb30978bd-21ea-47b1-bcde-1926b9444a84"
			],
			"style":{
				"font-family":"'Roboto', 'Arial', sans-serif",
				"font-size":"2.5vw",
				"font-weight":"700",
				"text-align":"left",
				"color":"rgba(235, 235, 235, 1)",
				"margin-top":"0vw",
				"margin-bottom":"0vw",
				"margin-left":"1vw",
				"margin-right":"0vw"
			}
		}
	],
	"pages":[
		{
			"frames":[
				{
					"component":{
						"type":"wrapper",
						"stylable":[
							"background",
							"background",
							"background-image",
							"background-repeat",
							"background-attachment",
							"background-position",
							"background-size"
						],
						"attributes":{
							"id":"i5rl"
						},
						"components":[
							{
								"type":"div",
								"attributes":{
									"id":"Cf3d3d78b-3ad4-4afd-a1b7-b2fe41d9c616",
									"data-action":"",
									"data-no-actions":"",
									"data-not-deletable":"",
									"data-not-resizable":"",
									"data-not-copiable":""
								},
								"components":[
									{
										"type":"div",
										"name":"Container",
										"attributes":{
											"id":"Ce373dd09-dd9e-4116-89c0-24040286d538",
											"data-action":""
										},
										"components":[
											{
												"type":"image",
												"name":"Image",
												"resizable":{
													"ratioDefault":1
												},
												"attributes":{
													"id":"Cbcb826a2-876a-44bb-9cbf-b282719c4d6e",
													"asset-id":"",
													"src":embeddedImagesBase64.scopeCube,
												}
											},
											{
												"type":"e-text",
												"name":"Text",
												"content":"Title",
												"attributes":{
													"id":"Cb30978bd-21ea-47b1-bcde-1926b9444a84",
												}
											}
										],
										"custom-name":"Banner",
										"__prev-display":"flex"
									},
									{
										"type":"div",
										"name":"Home Button",
										"classes":[
											"secondary-icon-cta"
										],
										"attributes":{
											"id":"C131bc0b8-e68c-4e99-8146-ef805a9457cd",
											"data-action":""
										},
										"components":[
											{
												"type":"image",
												"name":"Icon",
												"resizable":{
													"ratioDefault":1
												},
												"attributes":{
													"id":"C362cc898-d7a2-4ba3-9dc8-72697c95cb5a",
													"asset-id":"",
													"src":embeddedImagesBase64.home,
													"data-action":""
												}
											}
										]
									},
									{
										"type":"div",
										"attributes":{
											"id":"Ca71e6c6c-5d67-4444-8b21-4a816f989b40",
											"data-action":""
										},
										"components":[
											{
												"type":"div",
												"name":"Next Button",
												"classes":[
													"primary-icon-cta"
												],
												"attributes":{
													"id":"Cd08a9630-2986-4590-9960-4cabf0a3df30",
													"data-action":"next_step"
												},
												"components":[
													{
														"type":"image",
														"name":"Icon",
														"resizable":{
															"ratioDefault":1
														},
														"attributes":{
															"id":"Cc4797c47-683c-4177-9edf-7d2f5a0d4e5c",
															"asset-id":"",
															"src":embeddedImagesBase64.next,
														}
													}
												]
											},
											{
												"type":"div",
												"name":"Previous Button",
												"classes":[
													"secondary-icon-cta"
												],
												"attributes":{
													"id":"C90e696e9-8cf9-49b9-888b-17f2223c60cc",
													"data-action":"previous_step"
												},
												"components":[
													{
														"type":"image",
														"name":"Icon",
														"resizable":{
															"ratioDefault":1
														},
														"attributes":{
															"id":"Cb137d437-f3c7-4e93-b933-cb2a3fd5e144",
															"asset-id":"",
															"src":embeddedImagesBase64.prev,
														}
													}
												]
											}
										],
										"custom-name":"Prev/Next Buttons",
										"__prev-display":"flex"
									}
								],
								"custom-name":"Template Container"
							}
						],
						"custom-name":"Blank"
					},
					"id":"4dEPtAQRbQ3ZvKRV"
				}
			],
			"type":"main",
			"id":"kOCGgDvnkDAuSz8T"
		}
	]
};

export default GjsTemplateBlank;